import { Button } from 'components';
import {
  handleSave,
  outcomes,
  handleSubmitDisabled,
  handleThirdPartyValidations,
  handleCheckUniqueness,
  isBeneficiary,
  isAuditor,
  isObjectionCommittee
} from 'utils';
import { ReactComponent as Check } from 'assets/icons/check.svg';
import { ReactComponent as SaveIcon} from 'assets/icons/save_icon.svg'
import { submitFinalTask, thirdPartyValidations } from 'store/forms/actions';
import { getLocalString, localNames } from "utils/localisation.service";
import locale from 'antd/lib/date-picker/locale/el_GR';
import { validAFM } from 'utils';
import { isNil } from 'lodash';
import { updateFormField, checkUniqueness } from 'store/forms/actions';

export const renderButtons = ({
  task,
  state,
  dispatch,
  saveTask,
  taskId,
  formId,
  setIsVisible,
  setOutcome,
  setCancelModalVisible,
  user,
  viewMode,
  applStatus,
  setVisibleBanner,
  setRejectReasons,
  setInvalidModalVisible,
  locales
}) => {
  const formKey = task.formKey;
  const isSaved = state?.carrier?.rejectReasons?.isSubmitValid ? true : false;
  const isUserKTP = ( user.groups?.filter(a => a.id.startsWith("KTP")).length >0 )  ? ( user.groups?.filter(a => a.id.startsWith("KTP")).length >0 ) : false;


  return (
    <div className="app-layout__buttons">
      {
      !viewMode && (isBeneficiary(user?.groups) || isAuditor(user?.groups) || isObjectionCommittee(user?.groups)) && 
      // user.privileges?.includes("CanRenderSaveBtn") && 
      (
        <Button
          type="default"
          id="save"
          className="saveButton"
          label={getLocalString(locales,localNames.REQUEST_PAGE_SAVEBUTTON)}
          disabled={!isSaved}
          onClick={() => handleSave({
            state,
            dispatch,
            saveTask,
            taskId,
            formId,
            isSaved,
          })
          }
        />
      )}
      {/* { !viewMode && isBeneficiary(user?.groups) &&  
      // user.privileges?.includes("CanRenderSubmitBtn") && 
      (
        <Button
          type="default"
          className={"ant-btn-primary cancelButton"}
          label={'Ακύρωση'}
          disabled={false}
          onClick={() => {
            setOutcome(outcomes.cancelBeneficiary);
            setCancelModalVisible(true);
            }}
        />
      )} */}
      { !viewMode && isBeneficiary(user?.groups) && 
      (
        <Button
          type="default"
          className={"ant-btn-primary submit-btn"}
          label={getLocalString(locales,localNames.REQUEST_PAGE_SUBMISSIONBUTTON)}
          disabled={
            handleSubmitDisabled({
            user: { ...user},
            state: { ...state },
            formKey,
          })
        }
          onClick={() => {
            if(task.taskName !== "task.name.application_submission"){
              setOutcome(
                      isBeneficiary(user?.groups) && task.taskName === "task.name.temporary_rejected" ? 
                        outcomes.objectionBeneficiary
                        :
                        outcomes.submitBeneficiary 
                    );
              setIsVisible(true)
            }
            else {
              handleCheckUniqueness({
                user,
                state,
                dispatch,
                // submitValidation,
                checkUniqueness
              }).then(res => {
                const reasons ={
                  case:'submitValidation',
                  acceptable: res.acceptable,
                  responseCode: res.responseCode,
                  checks: res.checks,
                  equipmentType: state?.carrier?.equipmentType, //0 for outside check
                  }

                  if (reasons.acceptable) {
                    setOutcome(outcomes.submitBeneficiary);
                    setIsVisible(true);
                  } else {
                    setRejectReasons(reasons);
                    setInvalidModalVisible(true);
                  }
              }
            )
          }
        }}
        />
      )}
      { !viewMode && (isAuditor(user?.groups) || isObjectionCommittee(user?.groups)) &&  
      // user.privileges?.includes("CanRenderSubmitBtn") && 
      (
        <Button
          type="default"
          className={"ant-btn-primary submit-btn"}
          // label={getLocalString(locales,localNames.REQUEST_PAGE_SUBMISSIONBUTTON)}
          label={'Έγκριση'}
          disabled={
            handleSubmitDisabled({
            user: { ...user},
            state: { ...state },
            formKey,
            approve: true
          })
        }
          onClick={() => {
            setOutcome(
              isAuditor(user?.groups) ? 
                outcomes.auditApprove :
              isObjectionCommittee(user?.groups) ?
                outcomes.objectionCommitteeApprove 
              : '');
            setIsVisible(true);
            }}
        />
      )}
      { !viewMode && (isAuditor(user?.groups) || isObjectionCommittee(user?.groups)) &&  
      // user.privileges?.includes("CanRenderSubmitBtn") && 
      (
        <Button
          type="default"
          className={"ant-btn-primary reject-btn"}
          // label={getLocalString(locales,localNames.REQUEST_PAGE_SUBMISSIONBUTTON)}
          label={'Απόρριψη'}
          disabled={
            handleSubmitDisabled({
            user: { ...user},
            state: { ...state },
            formKey,
            approve:false
          })
        }
          onClick={() => {
            setOutcome(
              isAuditor(user?.groups) ? 
                outcomes.auditReject :
              isObjectionCommittee(user?.groups) ?
                outcomes.objectionCommitteeReject 
              : '');
            setIsVisible(true);
            }}
        />
      )}
      { !viewMode && isUserKTP && (
        <Button
          type="default"
          className={"ant-btn-primary reject-btn"}
          label={getLocalString(locales,localNames.REQUEST_PAGE_OUTLINE_REJECT)}
          // disabled={
          //   handleSubmitDisabled({
          //   user: { ...user},
          //   state: { ...state },
          //   formKey,
          // })}
          disabled={viewMode}
        //   icon={
        //     <Check width={15} height={15} className={'mr-1'} />
        // }
          onClick={() => {
              setOutcome(outcomes.rejectImplementer);
              setIsVisible(true);
          }
            }
        />
      )}
      { !viewMode && isUserKTP  && (
        <Button
          type="default"
          className={"ant-btn-primary submit-btn"}
          label={getLocalString(locales,localNames.REQUEST_PAGE_OUTLINE_APPROVE)}
          // disabled={
          //   handleSubmitDisabled({
          //   user: { ...user},
          //   state: { ...state },
          //   formKey,
          // })}
          disabled={viewMode}
        //   icon={
        //     <Check width={15} height={15} className={'mr-1'} />
        // }
          onClick={() => {
              setOutcome(outcomes.approveImplementer);
              setIsVisible(true);
          }
            }
        />
      )}
     </div>
  );
};
